import "@fontsource/inter";
import "@fontsource/inter/500.css";
import styled from "styled-components";
import { theme } from "../../../theme";
import type { FC } from "react";
import { SortingArrowsIcon } from "../icons/SortingArrowsIcon";

const TableHeaderText = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: number | string;
}>`
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  font-weight: ${(props) => props.fontweight ?? 500};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export default TableHeaderText;

interface Props {
  onClickSorting?: () => void;
  children: React.ReactNode;
  otherIcon?: React.ReactNode;
}

const SortingContainer = styled.button`
  display: flex;
  gap: 8px;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  :hover {
    filter: opacity(0.8);
  }
`;

export const TableHeaderTextSorting: FC<Props> = ({
  onClickSorting,
  children,
  otherIcon,
}) => {
  return (
    <SortingContainer
      onClick={onClickSorting}
      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
    >
      <TableHeaderText>{children}</TableHeaderText>
      {otherIcon ? otherIcon : <SortingArrowsIcon />}
    </SortingContainer>
  );
};
